<template>
  <div
    class="form-group"
    :class="{ 'has-error': errors.has(name), 'form-group-active': active }"
  >
    <label class="control-label" v-if="label">{{ label }}</label>
    <select
      v-if="options"
      ref="select"
      class="form-control"
      :class="selectClass"
      :value="value"
      :name="name"
      :readonly="readonly"
      :disabled="disabled"
      :data-vv-as="label"
      @input="$emit('input', $event.target.value)"
      @change="$emit('input', $event.target.value)"
      @blur="changeFocus()"
      @focus="changeFocus()"
    >
      <option value>{{ placeholder }}</option>
      <option
        v-for="option in options"
        :key="option.value"
        :value="option.value"
        >{{ option.text }}</option
      >
    </select>
    <p class="help-block" v-if="help">{{ help }}</p>

    <error-message :message="errors.first(name)"></error-message>
  </div>
</template>

<script>
export default {
  inject: ["$validator"],
  name: "form-group-select",
  props: {
    label: String,
    id: String,
    name: String,
    disabled: Boolean,
    placeholder: String,
    readonly: Boolean,
    required: String,
    value: [String, Object, Number, Boolean],
    options: Array,
    selectClass: String,
    help: String
  },
  mounted() {
    this.$el.value = this.value;
  },
  data() {
    return {
      active: false
    };
  },
  methods: {
    changeFocus() {
      this.active = !this.active;
    }
  }
};
</script>

<style>
select.input-sm {
  height: 35px;
  line-height: 30px;
}
</style>



// WEBPACK FOOTER //
// src/components/UIComponents/Forms/FormGroupSelect.vue